import { createGlobalStyle } from 'styled-components';
import '@fontsource/roboto';
import 'react-toastify/dist/ReactToastify.css';
import './globals.css';
import 'react-phone-input-2/lib/style.css';

export const GlobalStyle = createGlobalStyle`
  a{
  user-select: auto;
  -webkit-user-select: auto;
  -moz-user-select: auto;
  -ms-user-select: auto;
  } 
  
  html {
  /* overscroll-behavior-y: contain; */
  /* overflow-y: hidden; */
      /* overscroll-behavior: none ; */

  }

  body {
    height: 100%;
    width: 100%;
    /* overflow: hidden; */
    /* overscroll-behavior-y: contain; */
    /* overscroll-behavior: none ; */
    /* overflow-x: hidden; */
    /* background-color: var(--heltar-bg-surface); */
    font-family:  Roboto, sans-serif;
    font-size: 16px;
    touch-action: manipulation;
  }

  #root {
    min-height: 100%;
    min-width: 100%;
  }

/* Calendar icon styling using theme variables */
::-webkit-calendar-picker-indicator {
  cursor: pointer;
}
/* Additional approach using CSS filter for browsers that need it */
@media (prefers-color-scheme: dark) {
  ::-webkit-calendar-picker-indicator {
    filter: invert(0.8);
  }
}
/* For Firefox styling */
input[type="datetime-local"] {
  color-scheme: auto; 
}
input[type="datetime-local"] {
  padding-right: 10px;
}

 @media (max-width: 980px) {
  * {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;   
    -ms-user-select: none;     
  }
}

  p,
  h1,
  label {
    line-height: 1.4em;
  }

  input, select, textarea {
    font-size: inherit;
    font-family:  Roboto, sans-serif;
  }

  .tableHeading{
    background-color: var(--heltar-border-default);
    cursor: auto;
  }

  .scrollRemove {
    ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .scrollRemoveHorizontal{
    overflow-x: hidden;
    overflow-y: auto;
  }

  .scrollRemoveVertical{
    overflow-x: auto;
    overflow-y: hidden;
  }

  .scrollResize {
    ::-webkit-scrollbar {
      width: 6px;
      height: 8px;
    }
    ::-webkit-scrollbar-track {
      background-color: var(--heltar-scrollbar-track);
    }
    ::-webkit-scrollbar-thumb {
      background-color: var(--heltar-scrollbar-thumb);
      min-height: 50px
    }
    ::-webkit-scrollbar-thumb:hover {
        background-color: var(--heltar-scrollbar-thumb-hover);
    }
  }
.scrollResize2 {
  --scrollbar2-thumb-color: transparent;
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar2-thumb-color);
    min-height: 50px;
    min-width: 50px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: var(--heltar-scrollbar-thumb-hover);
  }
  &:hover {
    --scrollbar2-thumb-color: var(--heltar-scrollbar-thumb);
  }
}

.scrollShadcn {
  --scrollbar-thumb-color: transparent;
  --scrollbar-thumb-radius: 0;
  --scrollbar-size: 8px;
  ::-webkit-scrollbar {
    width: var(--scrollbar-size);
    height: var(--scrollbar-size);
    cursor: default;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
    cursor: default;
  }
  ::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-thumb-color);
    border-radius: var(--scrollbar-thumb-radius);
    min-height: 50px;
    cursor: default;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: hsl(var(--border) / 0.7);
    cursor: default;
  }
  ::-webkit-scrollbar-corner {
    background-color: hsl(var(--border));
  }
  ::-webkit-scrollbar-button {
    display: none;
  }
  &:hover {
    --scrollbar-thumb-color: hsl(var(--border));
  }

  /* Modifier: Always visible thumb */
  &.scrollShadcn-visible {
    --scrollbar-thumb-color: hsl(var(--border));
  }

  /* Modifier: Rounded thumb */
  &.scrollShadcn-rounded {
    --scrollbar-thumb-radius: 9999px;
  }

  /* Modifier: Show arrow buttons */
  &.scrollShadcn-arrows {
    ::-webkit-scrollbar-button {
      display: block;
      background-color: transparent;
      height: 7px;
      width: var(--scrollbar-size);
    }
    ::-webkit-scrollbar-button:single-button:vertical:decrement {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 6'%3E%3Cpolygon points='5,0 10,6 0,6' fill='%23666666'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center bottom;
      background-size: 8px 5px;
    }
    ::-webkit-scrollbar-button:single-button:vertical:increment {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 6'%3E%3Cpolygon points='0,0 10,0 5,6' fill='%23666666'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: center top;
      background-size: 8px 5px;
    }
    ::-webkit-scrollbar-button:single-button:horizontal:decrement {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 10'%3E%3Cpolygon points='0,5 6,0 6,10' fill='%23666666'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right center;
      background-size: 5px 8px;
    }
    ::-webkit-scrollbar-button:single-button:horizontal:increment {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 10'%3E%3Cpolygon points='6,5 0,10 0,0' fill='%23666666'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: left center;
      background-size: 5px 8px;
    }
  }

  /* Modifier: Small scrollbar */
  &.scrollShadcn-sm {
    --scrollbar-size: 6px;
  }

  /* Modifier: Large scrollbar */
  &.scrollShadcn-lg {
    --scrollbar-size: 12px;
  }
}

  .LazyLoad {
    opacity: 0;
    transition: all 1s ease-in-out;
  }

  .is-visible {
    opacity: 1;
  }
`;
